import * as React from 'react';
import * as Cookies from 'universal-cookie';

export interface ICookieConsentProps {}
interface ICookieConsentState {
    display: boolean;
}

export default class CookieConsent extends React.Component<
    ICookieConsentProps,
    ICookieConsentState
> {
    constructor(props: ICookieConsentProps) {
        super(props);

        const cookies = new Cookies();

        this.state = {
            display: cookies.get('cookies-consent') || false
        };
    }

    onClickHide() {
        const cookies = new Cookies();

        cookies.set('cookies-consent', true, { path: '/' });
        this.setState({ display: true });
    }

    render() {
        return (
            <div>
                {this.state.display === false && (
                    <div>
                        <div className="cookies-consent">
                            <p>
                                WetNotes uses cookies to enhance your browsing
                                experience. By using WetNotes you agree with
                                storing cookies in your browser.
                            </p>
                            <button
                                onClick={() => this.onClickHide()}
                                className="btn btn--smallpill btn--backroundRed btn--borderRed"
                            >
                                OK
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CookieConsent.tsx